package com.solevo.dist.application.models

data class ProductItem(
    var productId: String = "",
    var name: String = "",
    var quantity: Double = 0.0,
    var remainingQuantity: Double? = null,
    var remainingAmount: Double = 0.0,
    var pricePerUnit: Double? = null,
    var totalPrice: Double? = null,
    var unit: String? = "",
    var lineNumber: Double = 0.0,
    var warehouse: String? = null,
)

fun OrderLine.toProductItem(name: String): ProductItem {
    return ProductItem(
        productId = productId,
        name = name,
        totalPrice = totalPrice,
        remainingAmount = remainingAmount ?: 0.0,
        quantity = quantity,
        remainingQuantity = remainingQuantity,
        pricePerUnit = pricePerUnit,
        unit = unit,
        lineNumber = lineNumber
    )
}

fun DeliveryNoteLine.toProductItem(name: String): ProductItem {
    return ProductItem(
        productId = productId,
        name = name,
        quantity = quantity,
        unit = unit,
        lineNumber = lineNumber,
        warehouse = if(warehouseName?.isNotEmpty() == true) warehouseName else "-"
    )
}

fun InvoiceLines.toProductItem(name: String): ProductItem {
    return ProductItem(
        productId = productId ?: "",
        name = name,
        quantity = quantity,
        pricePerUnit = pricePerUnit,
        totalPrice = totalPrice,
        unit = unit,
        lineNumber = lineNumber
    )
}